<template>
  <div>
    <div
        v-if="show"
        class="d-flex justify-content-center align-items-center"
        style="height: 50vh;"
    >
      <b-spinner
          label="Spinning"
      />
    </div>
    <b-card
        v-if="!show"
    >
      <div class="d-flex justify-content-end">
        <b-button variant="primary" class="mb-2 ml-auto" href="/news/create">Создать</b-button>
      </div>
      <b-table
          responsive="sm"
          :items="users"
          :fields="tableColumns"
      >
        <template v-slot:cell(actions)="data">
          <b-button
              v-b-modal.modal-warning-edit
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="warning"
              class="btn-icon mr-1"
              :href="`news/edit/${data.item.slug}`"
          >
            <feather-icon icon="Edit2Icon"/>
          </b-button>
          <b-button
              variant="gradient-danger"
              class="btn-icon"
              @click="confirmDelete(data.item)"
          >
            <feather-icon icon="TrashIcon"/>
          </b-button>
        </template>
        <!-- <template #cell(logo)="data">
            <b-avatar
              v-if="data.item.logo"
              class="mr-1"
              :src="`${IMG_URL}${data.item.logo}`"
            />
          </template> -->
      </b-table>
<!--      <b-pagination-->
<!--          v-model="currentPage"-->
<!--          hide-goto-end-buttons-->
<!--          :total-rows="rows"-->
<!--          :per-page="perPage"-->
<!--          @input="getNews"-->
<!--      />-->
    </b-card>
  </div>
</template>

<script>
// import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {required} from '@validations'
import Ripple from 'vue-ripple-directive'
import {
  //   BAvatar,
  BButton,
  BCard,
  BTable,
  VBModal,
  BPagination,
  BSpinner,
} from 'bootstrap-vue'
import axios from 'axios'
import {$themeConfig} from '@themeConfig'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {codeSeparated} from '../Pagination/code'

export default {
  components: {
    BButton,
    BTable,
    BCard,
    BPagination,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      IMG_URL: $themeConfig.app.IMG_URL,
      isPendingExport: false,
      passValue: '',
      username: '',
      required,
      users: [],
      show: true,
      tableColumns: [
        {
          key: 'id',
          label: '#',
          sortable: true,
        },
        {
          key: 'title',
          label: 'Заголовок',
          sortable: true,
        },
        {
          key: 'slug',
          label: 'Страница',
        },
        {
          key: 'actions',
          label: 'Действия',
        },
      ],
      user: {
        id: '',
        name: '',
        email: '',
        phone: '',
        address: '',
      },
      codeSeparated,
      currentPage: 1,
      rows: 50,
      perPage: 15,
    }
  },
  mounted() {
    this.getNews(1)
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          alert('login successfully')
        }
      })
    },
    getNews(page) {
      this.show = true
      axios.get(`${$themeConfig.app.API}v2/admin/news?per_page=${this.perPage}&page=${page}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      })
          .then(res => {
            this.users = res.data.data
            this.rows = res.data.meta.total
            this.perPage = res.data.meta.per_page
            this.show = false
          })
          .catch(er => {
            console.log(er)
            this.show = false
          })
    },
    resetModal() {
      this.user.name = ''
      this.user.id = ''
      this.user.phone = ''
      this.user.email = ''
      this.user.address = ''
    },
    // eslint-disable-next-line no-unused-vars
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      // bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleEdit()
    },
    async handleEdit() {
      const myFormData = new FormData()
      myFormData.append('name', this.user.name)
      myFormData.append('email', this.user.email)
      myFormData.append('phone', this.user.phone)
      myFormData.append('id', this.admin.id)
      //   if (this.admin.file) {
      //     myFormData.append('logo', `${await this.getBase64(this.admin.file)}`)
      //   }
      myFormData.append('_method', 'PUT')
      // Edit request
      if (this.admin.id !== '') {
        await axios({
          method: 'post',
          url: `${$themeConfig.app.API}v2/admin/news/${this.admin.id}`,
          data: myFormData,
          config: {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          },
        })
            .then(() => {
              this.getAdmins()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Успешно',
                  text: 'Данные были изменены',
                  icon: 'CheckSquareIcon',
                  variant: 'success',
                },
              })
            })
            .catch(e => {
              console.log(e)
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Ошибка',
                  text: e.message,
                  icon: 'CheckSquareIcon',
                  variant: 'danger',
                },
              })
            })
      }
      // // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },
    edit(data) {
      this.admin.name = data.name
      this.admin.id = data.id
      this.admin.email = data.email
      this.admin.phone = data.phone
    },
    confirmDelete(data) {
      this.$bvModal
          .msgBoxConfirm('После удаления данные восстановить нельзя будет!', {
            title: 'Вы уверены что хотите удалить?',
            size: 'sm',
            okVariant: 'primary',
            okTitle: 'Удалить',
            cancelTitle: 'Отменить',
            cancelVariant: 'outline-secondary',
            hideHeaderClose: false,
            centered: true,
          })
          .then(value => {
            if (value) {
              axios.delete(`${$themeConfig.app.API}v2/admin/news/${data.id}`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
              })
                  .then(() => {
                    this.getNews()
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Успешно',
                        text: 'Данные были удалены',
                        icon: 'CheckSquareIcon',
                        variant: 'success',
                      },
                    })
                  })
                  .catch(e => {
                    console.log(e)
                    this.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Ошибка',
                        text: e.message,
                        icon: 'CheckSquareIcon',
                        variant: 'dander',
                      },
                    })
                  })
            }
          })
    },
    getBase64(file) {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => {
          resolve(reader.result)
        }
        reader.readAsDataURL(file)
      })
    },
  },
}
</script>
